import { campaignStatus, CAMPAIGN_STATUS_LABELS } from '@iws/theme-schema/campaign'

import { Badge } from '@/components/ui/badge'
import { OfferModel } from '@/types'

import { CAMPAIGN_STATUS_TONES } from './status-styles'

/** Draft / Scheduled / Live / Paused / Ended, derived from status and dates (no backend change). */
export const CampaignStatusBadge = ({ campaign, className }: { campaign: Pick<OfferModel.Offer, 'status' | 'starts_at' | 'ends_at'>; className?: string }) => {
  const status = campaignStatus(campaign)
  return <Badge tone={CAMPAIGN_STATUS_TONES[status]} className={className}>{CAMPAIGN_STATUS_LABELS[status]}</Badge>
}
